import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";

export const shareLinearConfigurationsConfirmationPageQueryOptions = () =>
  queryOptions({
    queryKey: pageDataKeys.page("sendLinearConfigurationsViaEmail/confirmation"),
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<void>>("/page-data/sendLinearConfigurationsViaEmail/confirmation"),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
